import styled from 'styled-components';

export const PavementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > .button {
    display: flex;
    margin-top: 1rem;
    margin-left: 11rem;
    margin-bottom: 1rem;
    flex-direction: row;
    padding: 0.313rem 0.938rem;
    justify-content: center;
    align-items: center;
    width: 11.675rem;
  }
`;

export const ButtonFaceliftContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  margin-left: -17rem;
  margin-bottom: 1rem;
  flex-direction: row;
  padding: 0.313rem 0.938rem;
  justify-content: center;
  align-items: center;
`;
